var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"an-situation row"},_vm._l((_vm.situations),function(situation,i){return _c('div',{key:i,class:[
      'an-situation__category',
      {
        'an-situation__category--danger':
          (_vm.$store.state.printMode || _vm.visualisation_gotVisible) &&
          situation.value < 4
      },
      'col-6',
      'col-md-2'
    ]},[_c('h3',{staticClass:"an-situation__heading"},[(situation.value < 4)?_c('IconWarning',{staticClass:"icon-warning",attrs:{"aria-hidden":"true"}}):_vm._e(),_c('span',[_vm._v(_vm._s(situation.title))])],1),_c('div',{staticClass:"an-situation__battery",style:({
        '--value':
          _vm.$store.state.printMode || _vm.visualisation_gotVisible
            ? ("-" + (situation.value * -10 + 100) + "%")
            : '0%'
      }),attrs:{"aria-label":((situation.value) + " von 10")}},[_c('div',{staticClass:"an-situation__progressbar"}),_c('div',{staticClass:"an-situation__battery-sections row flex-no-wrap"},_vm._l((10),function(section){return _c('div',{key:section,staticClass:"col-6"})}),0)])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }